import { render } from "./PatientForm.vue?vue&type=template&id=751335cc"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__